/* eslint-disable */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'

import FlexBox from '../common/FlexBox'
import Icon from '../common/Icon'
import { Tab } from './OrderHistoryFilter'

import { pad } from '../../utils/number'
import zIndexScale from '../../utils/zIndexScale'
// import { getCalendarLocale } from '../../utils/locales';
import { withI18n } from '../../i18n/util'

const Calendar = React.lazy(() => import('react-calendar'))

const MIN_DATE = '2017-07-14' // default minimum date

const InputContainer = styled(FlexBox)`
  position: relative;
  .react-calendar {
    background: ${({ theme }) => theme.dropdownBg};
    box-shadow: ${({ theme }) => theme.boxShadow};
    border: none;
  }
  .react-calendar__tile {
    color: ${({ theme }) => theme.calendarButtonEnable};
    &:hover {
      border-radius: 3px;
    }
  }
  .react-calendar__navigation {
    height: 3em;
    button {
      min-width: 14%;
      color: #848e9c;
    }
  }
  .react-calendar__navigation button[disabled],
  .react-calendar__month-view button.react-calendar__tile:disabled {
    background-color: ${({ theme }) => theme.dropdownBg};
    color: ${({ theme }) => theme.calendarButtonDisable};
  }
  .react-calendar__month-view__days__day--weekend {
    color: ${({ theme }) => theme.tradingViewStyle.short};
  }
  .react-calendar__tile--active {
    background: ${({ theme }) => theme.dropdownBg};
    border-radius: 3px;
    color: ${({ theme }) => theme.highlight};
  }
  .react-calendar__navigation button:enabled:focus,
  .react-calendar__tile:enabled:focus {
    background-color: ${({ theme }) => theme.dropdownBg};
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__navigation button:enabled:hover {
    background: rgba(240, 185, 11, 0.3);
    color: rgba(240, 185, 11);
  }
`

const CalendarOuter = styled(FlexBox)`
  background-color: ${({ theme }) => theme.boxaltheadbg};
  display: ${({ calendarOpen }) => (calendarOpen ? 'flex' : 'none')};
  left: 0px;
  bottom: 2.2em;
  position: absolute;
  z-index: ${zIndexScale.calendar};
  width: 200%;
`

const CalendarCTAContainer = styled(FlexBox)`
  padding: 0.5em;
  background: ${({ theme }) => theme.bg1};
  box-shadow: ${({ theme }) => theme.boxShadow};
`

const InputDate = styled.input`
  width: 9em;
  padding-left: 0.5em;
  height: 22px;
  background-color: ${({ theme }) => theme.inputBgColor};
  border: none;
  margin: 0 0.5em;
  outline: none;
  color: ${({ theme }) => theme.inputColor};
`

const IconWrap = styled.div`
  position: absolute;
  right: 5px;
  bottom: -3px;
  display: none;
  z-index: ${() => zIndexScale.zeroIndex};
  img {
    width: 20px;
  }
`

class CalendarInput extends React.PureComponent {
  static propTyps = {
    locale: PropTypes.string,
    defaultValue: PropTypes.date,
    minDateStr: PropTypes.string,
    maxDateStr: PropTypes.string,
    callbackFn: PropTypes.func,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    i18n: {},
    locale: 'en',
    minDateStr: '',
    defaultValue: '',
    maxDateStr: '',
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    const defaultValue = new Date(props.defaultValue)
    this.state = {
      date: defaultValue,
      calendarOpen: false,
      formatted: moment(defaultValue).format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
    window.addEventListener('mousedown', this._onClickedOutside)
    window.addEventListener('touchstart', this._onClickedOutside)
  }

  componentDidUpdate({ defaultValue }) {
    if (defaultValue !== this.props.defaultValue) {
      const date = this.props.defaultValue
      if (!date) {
        this.setState({ date: new Date(), calendarOpen: false, formatted: '' })
        return
      }
      const Y = date.getFullYear()
      const M = pad(date.getMonth() + 1)
      const D = pad(date.getDate())
      this.setState({ date, formatted: `${Y}-${M}-${D}` })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this._onClickedOutside)
    window.removeEventListener('touchstart', this._onClickedOutside)
  }

  _node = React.createRef()

  _setDate = date => {
    const Y = date.getFullYear()
    const M = pad(date.getMonth() + 1)
    const D = pad(date.getDate())
    const { callbackFn } = this.props
    this.setState({ date, formatted: `${Y}-${M}-${D}` }, () => {
      callbackFn(date)
    })
  }

  _resetDateInput() {
    this.setState({ formatted: '' })
  }

  _clear = () => {
    this.setState({ date: new Date(), calendarOpen: false, formatted: '' })
  }

  _confirm = () => {
    this._setDate(this.state.date)
    this.setState({ calendarOpen: false })
  }

  _toggleCalendar = () => {
    this.setState({ calendarOpen: !this.state.calendarOpen })
  }

  _onClickedOutside = ev => {
    if (!this.state.calendarOpen || !this._node) return
    if (this._node.current && this._node.current.contains(ev.target)) {
      return
    }
    this.setState({ calendarOpen: false })
  }

  _handleMinDate = () => {
    const { minDateStr } = this.props
    if (!minDateStr) return new Date(MIN_DATE)
    if (minDateStr !== '') return new Date(minDateStr)
    return new Date(MIN_DATE)
  }

  _handleMaxDate = () => {
    const { maxDateStr } = this.props
    if (!maxDateStr) return new Date()
    if (maxDateStr !== '' && new Date(maxDateStr) <= new Date()) {
      return new Date(maxDateStr)
    }
    return new Date()
  }

  render() {
    const { date, calendarOpen, formatted } = this.state
    const { formatI18nText } = this.props

    return (
      <InputContainer ref={this._node}>
        <CalendarOuter calendarOpen={calendarOpen} className="calendarOuter">
          <React.Suspense fallback="">
            <Calendar
              onChange={this._setDate}
              value={date}
              locale="en"
              onClickDay={this._confirm}
              minDate={this._handleMinDate()}
              maxDate={this._handleMaxDate()}
            />
          </React.Suspense>
          <CalendarCTAContainer basis="100%" justify="flex-end">
            <Tab onClick={this._clear}>{formatI18nText('exchange.calendar.clear')}</Tab>
            <Tab onClick={() => this._setDate(new Date())}>
              {formatI18nText('exchange.calendar.today')}
            </Tab>
            <Tab onClick={this._confirm}>{formatI18nText('exchange.calendar.ok')}</Tab>
          </CalendarCTAContainer>
        </CalendarOuter>
        <InputDate onFocus={this._toggleCalendar} type="text" value={formatted} />
        <IconWrap>
          <Icon type="calendar" color="#5A667C" />
        </IconWrap>
      </InputContainer>
    )
  }
}

export default withI18n(CalendarInput)
